export const HIGH_RES_PIXEL_RATIO = 4;

export function optimizeChartResolution(context, width, height, scale? ): void {
  if(!context?.canvas) return;
  context.canvas.style.width = `${width}px`;
  context.canvas.style.height = `${height}px`;

  scale =  scale || window.devicePixelRatio || 1;

  context.canvas.width = Math.floor(width * scale);
  context.canvas.height = Math.floor(height * scale);

  context.scale(scale, scale);
}